const projectsData = [
  {
    title: "E-Commerce 🛒",
    deployment: "https://github.com/devagya-rattan/E-Commerce",
    github: "https://github.com/devagya-rattan/E-Commerce",
    image: "https://devagya-rattan.netlify.app/images/ecommerce.png",
    description: "Multipurpose shopping ecommerce app provides amazing UI/Ux features and comes with diffrent ordering indpendence.It has functions like Paymnet Integration,add to cart and real tine API made using Strapi as its database",
  },
  {
    title: "Real Time Chat App 💬",
    deployment: "https://github.com/devagya-rattan/web-chat-application",
    github: "https://github.com/devagya-rattan/web-chat-application",
    image: "https://devagya-rattan.netlify.app/images/chatapp.png",
    description: "Developed a Real Time Chat Web Application using node.js,express.js and a webserver library socket.io. This project uses both backend and frontend tools. ",
  },
  {
    title: "Movie App 📽️",
    image: "https://devagya-rattan.netlify.app/images/moviesapp.png",
    deployment: "https://devagya-movie.netlify.app/",
    github: "https://devagya-movie.netlify.app/",
    description: "This a API based project which uses api key and react fetch funcionality to fetch data from the api data. It also comes with a search option which allows the user to search their favourite movies. ",
  },
  {
    title: "Ai Image-Gen 🤖",
    image: "https://devagya-rattan.netlify.app/images/imagegen.png",
    deployment: "https://64b00090475c560b69523406--friendly-sprite-0df71e.netlify.app/",
    github: "https://64b00090475c560b69523406--friendly-sprite-0df71e.netlify.app/",
    description: "This AI project uses Vite + React technology to run the host and an open AI based API key is used for getting data from the server. It can generate any ai images for the user as per their input text..",
  },
  {
    title: "To-Do-App 📃",
    image: "https://devagya-rattan.netlify.app/images/todo.png",
    deployment: "https://github.com/devagya-rattan/to-do-list-app",
    github: "https://github.com/devagya-rattan/to-do-list-app",
    description: "It is full stack Mern project which works on CRUD operations and data simultaneously gets updated in the backend(MONGO DB). You can add, read update and delete the list itms as per your requirements.",
  },
  {
    title: "Weather Application 🌤️",
    deployment: "https://weatherappdevagya.netlify.app/",
    github: "https://weatherappdevagya.netlify.app/",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIBv7-e50yai3xqW7mkLd4RDAPZo0j_CEfDA&usqp=CAU",
    description: "This weather app comes with a login functionality implemented with firebase. It allows the user to input name of the city and get all weather forecat information respectively.",
  },
  {
    title: "Resume Builder 📝",
    deployment: "https://resumebuilderdevagya.netlify.app/",
    github: "https://resumebuilderdevagya.netlify.app/",
    image: "https://miro.medium.com/v2/resize:fit:700/1*290ARQNbj_e0TTYZkQX6aA.png",
    description: "Resume builder apps make it easier to do so by prompting the user to fill in various fields with the appropriate information, then generating a clean, styled resume with that information. ",
  },
];

export default projectsData;
